import { CanDeactivateFn } from '@angular/router';
import { Observable } from 'rxjs';
import { WritableSignal } from '@angular/core';

export interface CanDeactivateComponent {
  pendingChangesCount: number;
  showLeaveConfirm: WritableSignal<boolean>;
  setLeaveResolve(fn: (allow: boolean) => void): void;
}

export const unsavedChangesGuard: CanDeactivateFn<CanDeactivateComponent> = (component) => {
  if (component.pendingChangesCount === 0) return true;
  component.showLeaveConfirm.set(true);
  return new Observable(observer => {
    component.setLeaveResolve((allow) => {
      observer.next(allow);
      observer.complete();
    });
  });
};
